export default __webpack_public_path__ + "media/maps/download-a5dc155e.svg";